<template>
  <VMenu
    ref="wrapper"
    v-model="modal"
    :disabled="$attrs.readonly"
    :return-value.sync="time"
    v-bind="{
      ...{
        closeOnContentClick : false,
        transition: 'scale-transition',
        offsetY: true,
        maxWidth: '290px',
        minWidth: '290px'
      },
      ...wrapperProps
    }"
  >
    <template #activator="{ on, attrs }">
      <VTextField
        :value="customTextFormat(time)"
        :label="label"
        v-bind="{
          ...attrs,
          clearable: true,
          prependIcon: 'mdi-clock-time-four-outline',
          readonly: true,
          ...$attrs
        }"
        v-on="on"
        @click:clear="clear"
      />
    </template>
    <VTimePicker
      v-model="time"
      v-bind="{
        ...{
          fullWidth: true,
          scrollable: true,
          locale: convertLocale(currentLocale, 'bcp47'),
        },
        ...timePickerProps
      }"
    >
      <VBtn
        text
        color="primary"
        @click="modal = false"
      >
        {{ $t('common.cancel') }}
      </VBtn>
      <VBtn
        text
        color="primary"
        @click="clear"
      >
        {{ $t('common.clear') }}
      </VBtn>
      <VSpacer />
      <VBtn
        color="primary"
        @click="$refs.wrapper.save(time)"
      >
        {{ $t('common.ok') }}
      </VBtn>
    </VTimePicker>
  </VMenu>
</template>

<script>
import moment from 'moment'
export default {
  components: {
  },
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined,
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    wrapperProps: {
      type: Object,
      default: () => {}
    },
    timePickerProps: {
      type: Object,
      default: () => {}
    },
    customTextFormat: {
      type: Function,
      default: (time) => {
        if (moment(time, 'HH:mm').isValid()) return moment(time, 'HH:mm').format('hh:mm A')
        else return ''
      }
    },
    clearValue: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      modal: false,
      time: this.value,
      wrapperPropsMapping: {
        VDialog: {
          persistent: true,
          width: '300px'
        }
      }

    }
  },
  watch: {
    value: {
      handler (val) {
        this.time = val
      },
      immediate: true
    },
    time (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    clear () {
      this.time = this.clearValue
    }
  }
}
</script>
